import { render, staticRenderFns } from "./DiffChangeLabel.vue?vue&type=template&id=85c3f852&scoped=true&"
import script from "./DiffChangeLabel.vue?vue&type=script&lang=js&"
export * from "./DiffChangeLabel.vue?vue&type=script&lang=js&"
import style0 from "./DiffChangeLabel.vue?vue&type=style&index=0&id=85c3f852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c3f852",
  null
  
)

export default component.exports